/*
 * @Date: 2022-12-28 09:58:32
 * @LastEditors: Leo
 * @LastEditTime: 2023-04-19 19:27:27
 * @FilePath: \3.0-manger\src\js\utils\index.js
 */
// 获取当前环境
export function getEnvironment() {
  let mode = 'dev'
  switch (window.shopId) {
    case "9709262": // US
    case "60738666677": // CA
    case "10015375438": // JP
    case "56981160124": // GB
    case "57272172741": // DE
    case "60455780502": // KR
    case "68984701213": // AU
    case "69511053598": // FR
    case "69224431898": // IT
    case "69013700929": // ES
    case "73356443969": // EU
    case "74688758050": // HK
    case "74914496810": // MO
      mode = 'prod';
      break;
    case "79611232554": // US uat
      mode = 'uat';
      break;
    default:
      mode = 'dev';
      break;
  }
  return mode;
}

import ScrollLoader from './scroll-loader';

// 导出ScrollLoader
export { ScrollLoader };

// 通用数据埋码
export const gaPushDataLayer = (eventName = 'users_click', params) => {
  // const CR = cookie.get("_jk_cr") || localStorage.getItem('JACKERY_ID_CR') || 'US'
  // Object.assign(params, { CR, country: CR, })
  const gaEvent = () => {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: {
        'current_page': window.location.href,
        ...params
      }
    });
  }
  window.dataLayer ? gaEvent() : setTimeout(() => gaEvent(), 3000)
}

// 商详页数据埋码
export const gaProductDetailDataLayer = (params) => {
  return gaPushDataLayer('products_details_page_user_clicks', params)
}

export const gaEduFaqDataLayer = (params) => {
  return gaPushDataLayer('section_FAQ_user_clicks', params)
}

/**
 * 指定容器下 - autoplay video
 * el - video 父元素
 */
export function autoplayVideo(el) {
  const video = el.querySelector('iframe[src*="www.youtube.com"], video');
  if (!video) return;

  if (video.tagName.toLowerCase() === 'video') {
    video.play();
    return
  }
  // video.src = `${video.src + (video.src.indexOf('?') < 0 ? '?' : '&')}autoplay=1`
  video.contentWindow.postMessage('{"event":"command","func":"' + 'mute' + '","args":""}', '*');
  video.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
}
/*
    指定容器下 - stop video
    el - video 父元素
*/
export function stopVideo(el) {
  const video = el.querySelector('iframe[src*="www.youtube.com"], video');
  if (!video) return;

  if (video.tagName.toLowerCase() === 'video') {
    video.pause();
    return
  }
  // video.src = video.src.replace('&autoplay=1', '').replace('?autoplay=1', '')
  video.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
}

/*
  header 距离
*/
export function calcTop() {
  const header = $(".site-header");
  const header_bar_show = $(".site-header").hasClass("announcement-bar-show");
  const header_h = $(".site-header .header-main ").height() || 0;
  const header_bar_h = header_bar_show ? $(".site-header .announcement-bar").height() || 0 : 0;
  return header_h + header_bar_h || $("jky-header").outerHeight() || 0
}

/**
 * set cookie
 * name             -       cookie name
 * value            -       cookie value
 * expireDays       -       cookie expire time
 * isDomain         -       是否放到主域名下
 */
export function setCookie(name, value, exDays, isDomain) {
  let d = new Date();
  const host = location.host;
  exDays = exDays || 7;
  d.setTime(d.getTime() + (exDays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toGMTString()}`;

  if (host.split('.').length === 1) {
    document.cookie = `${name}=${value}; ${expires}; path=/`
  } else {
    const domainParts = host.split('.');
    domainParts.shift();
    const domain = `.${domainParts.join('.')}`;
    document.cookie = `${name}=${value}; ${expires}; path=/; domain=${domain}`

    if (name == '_jk_user') {
      document.cookie = `${name}=${value}; ${expires}; path=/; domain=.jackery.com`
    }
    if (isDomain) {
      document.cookie = `${name}=${value}; ${expires}; path=/; domain=.jackery.com`
    }
  }
}

// 跨站点请使用这个方法操作cookie
export const cookie = {
  set(name, value, exDays = 7) {
    let d = new Date(), host = location.host;
    d.setTime(d.getTime() + (exDays * 24 * 60 * 60 * 1000));
    let expires = `expires=${d.toGMTString()}`;

    if (host.split('.').length === 1) {
      document.cookie = `${name}=${value}; ${expires}; path=/`
    } else {
      if (host.indexOf(".jackery.com") !== -1) {
        let domain = '.jackery.com';
        document.cookie = `${name}=${value}; ${expires}; path=/; domain=${domain}`
      } else {
        let domainParts = host.split('.');
        domainParts.shift();
        let domain = '.' + domainParts.join('.');
        document.cookie = `${name}=${value}; ${expires}; path=/; domain=${domain}`
      }
    }
  },
  get(n) {
    let name = n + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ""
  },
  erase(name) {
    this.set(name, "", -1)
  }
}

/**
 * get LocalStorage by name
 * name          -       LocalStorage name
 */
export function getLocalStorage(name) {
  try {
    return window.localStorage.getItem(name);
  } catch (e) {
    return ''; // private mode
  }
}

/** 下载pdf文件, 而不是直接在浏览器打开 */
export const downloadFile = (url) => {
  let blob = "";
  const xhr = new XMLHttpRequest();
  xhr.onload = function () {
    if (this.status === 200) {
      blob = new Blob([xhr.response], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = url.split('?').shift().split('/').pop()
      link.click();
    } else {
      console.log(`Error. Estatus ${this.status}.`)
    }
  };

  try {
    xhr.open('GET', url, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.responseType = 'blob';
    xhr.send(`parameter1=&parameter2=`);
  } catch (e) {
    console.log(e)
  }
}

/** 创建a链接下载 */
export const downloadFileByLink = (url, filename) => {
  if (!url) return
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  filename && link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * convert url params to object
 */
export const groupParamsByKey = (params = new URLSearchParams(location.search.substring(1))) => [...params.entries()].reduce((acc, tuple) => {
  const [key, val] = tuple;
  if (acc.hasOwnProperty(key)) {
    if (Array.isArray(acc[key])) {
      acc[key] = [...acc[key], val]
    } else {
      acc[key] = [acc[key], val];
    }
  } else {
    acc[key] = val;
  }

  return acc;
}, {});


/**
 * click copy
 *
 * @param {Element} value - copy string
 * @param {Element} cb - callback function
 */
export const copyString = (value, cb) => {
  const textarea = document.createElement('textarea')
  textarea.readOnly = 'readonly'
  textarea.style.position = 'absolute'
  textarea.style.left = '-9999px'
  textarea.value = value
  document.body.appendChild(textarea)
  textarea.select()
  // const result = document.execCommand('Copy')
  document.execCommand('Copy')
  document.body.removeChild(textarea)
  // if (result && cb) { cb() }
  cb && cb()
}

export function convertForm(formid) {
  const form = document.forms[formid]
  const param = {};
  for (let i = 0; i < form.length; i++) {
    if (form[i].type !== 'submit') {
      if (form[i].type === 'checkbox') {
        param[form[i].name] = form[i].checked
      } else {
        param[form[i].name] = form[i].value.trim()
      }
    }
  }

  return param
}

// get browser param, compatible with non-standard url param
export function shopGetParam(variable) {
  function nonstandard() {
    let v = location.href.split("&");
    v.splice(0, 1);
    return v
  }
  var query = window.location.search.substring(1), vars = query ? query.split("&") : nonstandard();
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) { return decodeURI(pair[1]) }
  }
  return false
}

export const isMobile = () => {
  // navigator.userAgent.match(/(iPhone|iPod|Android|ios|SymbianOS|BlackBerry|webOS)/i)
  // match 存在不兼容情况
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

// 判断是否时小于1024屏幕
export const isLessThan1024Screen = () => window.innerWidth < 1024;

export const verifyEmail = (str) => /^[A-Za-z0-9._%+!`#$^-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,8}$/.test(str)

export const validZip = (str) => {
  let exp = {
    "CN": /^[1-9][0-9]{5}$/,
    "US": /^\d{5}(?:[-\s]\d{4})?$/,
    "JP": /^[0-9]{3}-[0-9]{4}$/,
    "CA": /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
    "GB": /^([A-Z][A-HJ-Y]?\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/,
    "DE": /^[0-9]{5}$/,
    "AU": /^[0-9]{4}$/,
    "IT": /^(I-|IT-)?[0-9]{5}$/,
    "FR": /(^[0-8]\d\d{3}$)|(^9[0-5]\d{3}$)|(^97[1-6]\d{2}$)|(^98[46-8]\d{2}$)/,
    "ES": /^[0-9]{5}$/
  };
  return exp[str]
}

/**
 * 平滑滚动
 * position: 元素再body的位置
 */
export const scrollToTop = (position) => {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (cb) {
      return setTimeout(cb, 17)
    }
  }

  let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;

  const step = function () {
    const distance = position - scrollTop;
    scrollTop += distance / 5;
    if (Math.abs(distance) < 1) {
      window.scrollTo(0, position)
    } else {
      window.scrollTo(0, scrollTop);
      requestAnimationFrame(step)
    }
  };
  step()
}

export const countUp = (el, start, end, speed) => {
  let current = start;
  const interval = setInterval(() => {
    current += 1;
    let arr = current.toString().padStart(2, '0').split("");
    el.innerHTML = `<i>${arr[0]}</i><i>${arr[1]}</i>`
    if (current >= end) {
      clearInterval(interval)
    }
  }, speed || 100)
}

/**
 * @description countTime
 */

export const countTime = (target, current, element, callback) => {
  //time different, d,h,m,s save countdown
  let leftTime = target - current, d, h, m, s;
  if (leftTime >= 0) {
    d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
    h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
    m = Math.floor(leftTime / 1000 / 60 % 60);
    s = Math.floor(leftTime / 1000 % 60);

    if (element) {
      element.querySelector('._days').innerText = String(d).padStart(2, "0");
      element.querySelector('._hours').innerText = String(h).padStart(2, "0");
      element.querySelector('._mins').innerText = String(m).padStart(2, "0");
      element.querySelector('._secs').innerText = String(s).padStart(2, "0")
    }
    setTimeout(function () { countTime(target, current + 1000, element, callback) }, 1000)
  } else {
    // countdown end
    callback && callback()
  }
}
/**
 * 相同元素 水平等高处理
 * @param selector 元素
 */
export const matchHeight = (selector) => {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  // 找到最大高度
  for (let i = 0; i < elements.length; i++) {
    const elementHeight = elements[i].clientHeight;
    maxHeight = Math.max(maxHeight, elementHeight);
  }

  // 设置所有元素的高度为最大高度
  for (let j = 0; j < elements.length; j++) {
    elements[j].style.height = `${maxHeight}px`;
  }
}


// 是否为 iOS 移动终端
export const isiOS = () => !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)


// 视窗内拖拽移动
export class DragToMove {
  constructor({
    el, // 目标元素
    placement = 'left', // 目标位置，'left' - 靠左，'right' - 靠右
    offset = { // 偏移量
      x: 0,
      y: 0,
    },
    onClick, // 点击事件
    closable = false, // 是否可关闭
    closableEl, // 关闭按钮元素
    closedCallback, // 关闭回调
  }) {
    this.DOM = document.querySelector(el)

    this.placement = placement
    this.offset = offset
    this.onClick = onClick
    this.closable = closable
    this.closableEl = closableEl
    this.closedCallback = closedCallback

    this.isDragging = false // 是否正在拖拽
    this.isClick = false // 是否点击

    this.offsetX = 0
    this.offsetY = 0

    this.windowWidth = window.innerWidth

    // 事件绑定 this 指向，方便移除
    this.start = this.start.bind(this)
    this.move = this.move.bind(this)
    this.end = this.end.bind(this)
    this.resize = this.resize.bind(this)

    this.initPosition()
    this.initEvent()
  }
  resize() {
    if (this.windowWidth !== window.innerWidth) {
      this.windowWidth = window.innerWidth

      if (this.resizeTimer) clearTimeout(this.resizeTimer)

      this.resizeTimer = setTimeout(() => {
        this.initPosition()
      }, 500)
    }
  }
  // 初始化位置
  initPosition() {
    if (this.placement === 'left') {
      this.setPosition(this.offset.x, this.offset.y)
    } else {
      const { offsetWidth, offsetHeight, } = this.DOM
      const { clientWidth, clientHeight, } = document.documentElement

      if (this.offset.y.includes('%')) {
        this.setPosition(
          clientWidth - offsetWidth - (this.offset.x || 0),
          (clientHeight - offsetHeight) * parseInt(this.offset.y) / 100
        )
      } else {
        this.setPosition(clientWidth - offsetWidth - this.offset.x, clientHeight - offsetHeight - this.offset.y)
      }
    }
  }
  // 初始化方法
  initEvent() {
    // 禁止 DOM 元素的 drag 事件干扰
    this.DOM.addEventListener('dragstart', (e) => e.preventDefault())

    // PC
    this.DOM.addEventListener("mousedown", this.start, { passive: true })

    // Mobile
    this.DOM.addEventListener("touchstart", this.start, { passive: true })

    // 监听 resize
    window.addEventListener('resize', this.resize, false)
  }
  // 移除事件
  removeEvent() {
    // PC
    this.DOM.removeEventListener("mousedown", this.start, { passive: true })

    // Mobile
    this.DOM.removeEventListener("touchstart", this.start, { passive: true })

    // 监听 resize
    window.removeEventListener('resize', this.resize, false)
  }
  // 拖拽开始
  start(e) {
    this.isDragging = true
    this.isClick = true

    // 监听 move 事件
    document.addEventListener("mousemove", this.move, false)
    document.addEventListener("mouseup", this.end, { passive: true })

    this.DOM.addEventListener("touchmove", this.move, false)
    this.DOM.addEventListener("touchend", this.end, { passive: true })

    const event = e.touches ? e.touches[0] : e

    this.offsetX = event.clientX - this.DOM.offsetLeft
    this.offsetY = event.clientY - this.DOM.offsetTop
  }
  // 移动
  move(e) {
    if (this.isDragging) {
      e.preventDefault()
      e.stopPropagation()

      this.isClick = false

      const event = e.touches ? e.touches[0] : e

      const x = event.clientX - this.offsetX
      const y = event.clientY - this.offsetY

      const { clientWidth, clientHeight, } = document.documentElement

      const X = this.range(x, 0, clientWidth - this.DOM.offsetWidth)
      const Y = this.range(y, 0, clientHeight - this.DOM.offsetHeight)

      this.setPosition(X, Y)
    }
  }
  // 拖拽结束
  end(e) {
    this.isDragging = false
    e.stopPropagation()

    // 移除 move 事件
    document.removeEventListener("mousemove", this.move, false)
    document.removeEventListener("mouseup", this.end, { passive: true })

    this.DOM.removeEventListener("touchmove", this.move, false)
    this.DOM.removeEventListener("touchend", this.end, { passive: true })

    if (this.isClick && this.onClick) {
      if (this.closable && this.closableEl) {

        // closableEl 可能是 id，也可能是 class
        const name =
          (this.closableEl.includes('#') && e.target.id) ||
          (this.closableEl.includes('.') && e.target.className)

        if (name === this.closableEl.slice(1)) {
          this.DOM.style.display = 'none'
          this.closedCallback && this.closedCallback(e)

          // 移除事件
          this.removeEvent()
          return false
        }
      }

      this.isClick = false
      this.onClick()
    }
  }
  // 更新元素位置
  setPosition(x, y) {
    this.DOM.style.left = `${x}px`
    this.DOM.style.top = `${y}px`
    this.DOM.style.opacity = 1
  }
  // 判断边界
  range(loc, min, max) {
    if (loc > max) {
      return max
    }
    if (loc < min) {
      return min
    }
    return loc
  }
}


// 获取 滚动条 宽度
function getScrollBarWidth() {
  const rootStyles = getComputedStyle(document.documentElement);
  return rootStyles.getPropertyValue('--scroll-bar-width');
}

// 设置 内容区域 宽度，防止 页面闪烁
export function setContentWidth() {
  if (document.body.classList.contains('overflow-hidden')) return
  document.body.classList.add('overflow-hidden');

  if (window.innerWidth <= 1024) return
  const scrollBarWidth = getScrollBarWidth()
  document.body.style.paddingRight = scrollBarWidth;
}

// 恢复 内容区域 宽度
export function resetContentWidth() {
  if (!document.body.classList.contains('overflow-hidden')) return

  // 查找所有弹窗
  const modalList = document.querySelectorAll('.modal-container.modal')
  // 检查是否所有弹窗都已关闭
  const allModalsClosed = Array.from(modalList).every(item => item.style.display === 'none')
  // 只有当所有弹窗都关闭时，才恢复body滚动
  if (allModalsClosed) {
    document.body.classList.remove('overflow-hidden');

    if (window.innerWidth <= 1024) return
    document.body.style.paddingRight = 0;
  }
}


// 滚动到顶部
// export function scrollToTop() {
//   const c = document.documentElement.scrollTop || document.body.scrollTop

//   if (c > 1) {
//       window.requestAnimationFrame(scrollToTop)

//       // 计算新的滚动位置，避免无限接近 0 的小数问题
//       const n = c - c / 8

//       // 设置新的滚动位置
//       window.scrollTo(0, Math.max(n, 0))
//   } else {
//       // 如果当前滚动位置小于等于 1 像素，直接设置为 0
//       window.scrollTo(0, 0);
//   }
// }


export const dateFormat = (cr) => {
  let exp = {
    "CN": "YYYY-MM-DD",
    "HK": "DD-MM-YYYY",
    "US": "MM/DD/YYYY",
    "JP": "YYYY-MM-DD",
    "GB": "DD-MM-YYYY",
    "CA": "DD-MM-YYYY",
    "AU": "DD-MM-YYYY",
    "DE": "DD.MM.YYYY",
    "FR": "DD/MM/YYYY",
    "IT": "DD/MM/YYYY",
    "ES": "DD-MM-YYYY",
  };
  return exp[cr]
}

// 替换换行符为 <br>
export const replaceLineBreak = (str) => {
  if (str.includes('\n')) {
    return str.replace(/\n/g, '<br>');
  }
  return str
}



/**
 * 创建Checkout并直接跳转，需要开checkout的【读】和【写】权限
 * 当库存不足时，会弹出 Shopify 自带的库存不足提示
 * @param {Array} items - 商品列表数组，每个商品包含 quantity, id, properties
 * @returns {Promise}
 */
export const createCheckoutAndRedirect = (items) => {
  if (!Array.isArray(items)) {
    return console.log('items must be an array')
  }

  // 获取当前站点的域名
  const hostname = window.location.hostname;
  // 从 Map 中查找 Token
  const storefrontAccessToken = STOREFRONT_ACCESS_TOKEN?.get(hostname);

  return new Promise((resolve, reject) => {
    // 将 properties 转换为 GraphQL 格式
    const attributesToGraphQL = (properties = {}) => {
      const result = Object.entries(properties).map(([key, value]) => ({ key, value }));
      return result
        .map((attr) => `{key: "${attr.key}", value: "${attr.value}"}`)
        .join(', ');
    };

    // 新增满赠需求
    const fullItems = items.flatMap(item => {
      const giftList = window.fullGiftList?.find(item => item.id == item.id)?.autoBuyChildResps || [];
      return giftList ? giftList.map(giftItem => ({
        id: giftItem.id,
        quantity: Number(giftItem.quantity) * Number(item.quantity),
        properties: {

        }
      })) : [];
    });
    const lineItems = [...items, ...fullItems];

    // 构建 GraphQL 的 lines 输入
    const lines = lineItems
      .map(
        (item) => `{
          quantity: ${item.quantity},
          variantId: "gid://shopify/ProductVariant/${item.id}",
          customAttributes: [${attributesToGraphQL(item.properties)}]
        }`
      )
      .join(',');

    fetch('/api/2023-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
      body: JSON.stringify({
        query: `
          mutation {
            checkoutCreate(
              input: {
                lineItems: [${lines}]
              }
            ) {
              checkout {
                id
                webUrl
              }
            }
          }
        `
      })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.errors) {
          console.error('GraphQL Errors:', data.errors);
          reject(new Error('GraphQL request failed'));
        } else {
          const checkoutUrl = data.data.checkoutCreate.checkout.webUrl;
          resolve(checkoutUrl); // 返回结账 URL
        }
      })
      .catch((error) => {
        console.error('Error creating checkout:', error);
        reject(error);
      });
  })
}


/**
 * @function 有效时长计算
 * @param {number} val 输入值
 * @param {number} capacity 电池容量（Wh）
 * @param {number} efficiency 效率，默认：0.8
 * @param {number} acConsumption 损耗（W），默认：0
 *
 **/
export const getRunningTime = (val, capacity, efficiency = 0.8, acConsumption = 0) => {
  let result = 0;
  if (val && capacity) {
    result = ((capacity * efficiency) / (val + acConsumption)).toFixed(1);
  }
  return result;
}

/**
 * @function 使用当前设备多次节省费用计算
 * @param {number} capacity 电池容量（Wh）
 * @param {number} efficiency 效率，默认：0.8
 * @param {number} electricityCost 当地电单价（示例：英国 p/kWh）
 * @param {number} times 当前设备完全放空电次数
 * @returns
 */
export const getSavings = (capacity, efficiency = 0.8, electricityCost, times) => {
  let result = 0;
  if (capacity && electricityCost && times) {
    result = (capacity / 1000 * efficiency * electricityCost / 100 * times).toFixed(2);
  }
  return result;
}



/**
 * 视频播放器工具类
 * 提供视频顺序播放、暂停等功能
 */
export class VideoPlayer {
  /**
   * 初始化视频播放器
   * @param {Object} options 配置项
   * @param {Element} options.container 容器元素
   * @param {String} options.videoSelector 视频元素选择器
   * @param {Function} options.onTrack 数据埋点回调
   */
  constructor(options) {
    const { container, videoSelector = 'jky-video', onTrack } = options || {}

    this.container = container
    this.videoSelector = videoSelector
    this.onTrack = onTrack

    // 当前播放视频的索引
    this.curIndex = 0

    if (this.container) {
      // 获取所有视频元素
      const allVideos = this.container.querySelectorAll(this.videoSelector)

      // 过滤出显示状态的视频元素
      this.videos = Array.from(allVideos).filter(item => {
        const style = window.getComputedStyle(item)
        return style.display !== 'none' && style.visibility !== 'hidden'
      })

      // 是否都配置的 mp4 格式的视频
      const mp4Video = Array.from(this.videos).filter(item => item.getAttribute('video-type') === 'mp4')
      this.isAllMp4 = mp4Video.length === this.videos.length

      // 修正 this 指向，方便新增和移除事件
      this.videoEndedPlayEvent = this.videoEndedPlayEvent.bind(this)
    }
  }

  /**
   * 初始化视频点击事件
   */
  init() {
    if (!this.videos || !this.videos.length) return

    this.videos.forEach((item, index) => {
      const posterWrap = item.querySelector('.jky-video-poster_container')
      if (posterWrap) {
        posterWrap.onclick = () => {
          // 停止当前播放的视频
          this.stopAllVideos()

          // 设置当前索引并播放
          this.curIndex = index
          this.playVideo(item)
        }
      }
    })

    return this
  }

  /**
   * 停止所有视频播放
   */
  stopAllVideos() {
    if (!this.videos) return

    this.videos.forEach(it => {
      if (it && it.pause) {
        it.videoInfo.autoplay = false
        it.pause()

        // 移除事件监听
        if (this.isAllMp4) {
          it.querySelector('video')?.removeEventListener('ended', this.videoEndedPlayEvent)
        }
      }
    })

    return this
  }

  /**
   * 播放指定视频
   * @param {Element} curVideo 要播放的视频元素
   */
  playVideo(curVideo) {
    if (curVideo && curVideo.loadContent) {
      curVideo.videoInfo.autoplay = true
      curVideo.loadContent(false)

      if (this.isAllMp4) {
        // 监听视频播放完成事件
        curVideo.querySelector('video').addEventListener('ended', this.videoEndedPlayEvent)
      }

      this.trackVideoPlay(curVideo)
    }

    return this
  }

  /**
   * 跟踪视频播放数据
   * @param {Element} curVideo 当前播放的视频元素
   */
  trackVideoPlay(curVideo) {
    if (!this.onTrack) return

    // video
    if (curVideo.querySelector('video')) {
      // 监听 video 播放
      curVideo.querySelector('video').addEventListener('play', () => {
        this.sendTrackEvent(curVideo)
      })
    }
    // youtube 或者是 图片
    else {
      this.sendTrackEvent(curVideo)
    }
  }

  /**
   * 发送跟踪事件
   * @param {Element} curVideo 当前视频元素
   */
  sendTrackEvent(curVideo) {
    if (this.onTrack && typeof this.onTrack === 'function') {
      const data = curVideo.parentElement.dataset
      this.onTrack(data, curVideo)
    }
  }

  /**
   * 播放下一个视频
   */
  playNextVideo() {
    this.curIndex++
    // 检查是否还有下一个视频
    if (this.curIndex < this.videos.length) {
      const nextVideo = this.videos[this.curIndex]
      this.playVideo(nextVideo)
    }

    return this
  }

  /**
   * 视频播放完成事件
   */
  videoEndedPlayEvent(e) {
    // 标记视频已播放完成
    e.target.setAttribute('data-played', 'true')

    // 播放下一个
    this.playNextVideo()
  }

  /**
   * 观察视频是否进入视口
   * @param {Object} options 配置项
   * @param {Number} options.threshold 阈值
   */
  observe(options = {}) {
    const { threshold = 0.25 } = options

    // 视频进入视口监听播放
    const Observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const curVideo = this.videos[this.curIndex]
          // 如果视频未播放或播放完，则播放
          if (curVideo.querySelector('video')?.getAttribute('data-played') !== 'true') {
            // 播放视频
            this.playVideo(curVideo)
          }
        } else {
          // 暂停播放
          this.stopAllVideos()
        }
      })
    }, {
      root: null,
      rootMargin: '0px',
      threshold, // 设置阈值
    })

    Observer.observe(this.container)

    return this
  }
}


/**
 * 无缝循环滚动工具类
 * 支持用户通过鼠标滚轮滚动查看
 */
export class SeamlessScrolling {
  /**
   * 初始化无缝循环滚动
   * @param {Object} options 配置项
   * @param {Element} options.container 容器元素
   * @param {Element} options.delay 延迟滚动
   */
  constructor(options) {
    const { container, delay = 1000 } = options || {}
    this.container = container;
    this.speed = 40; // 像素/秒
    this.isScrolling = false;
    this.lastTimestamp = null;
    this.rafId = null;
    this.scrollAccumulator = 0;
    this.delay = delay || 1000;

    // 检查是否有足够的内容进行滚动
    const containerHeight = this.container.clientHeight;
    const contentHeight = this.container.scrollHeight;

    // 如果内容不足以滚动，则不进行处理
    if (contentHeight <= containerHeight) {
      return;
    }

    // 使用cloneNode替代innerHTML操作，更高效
    const originalContent = Array.from(this.container.children);
    if (originalContent.length === 0) return;

    // 优化DOM操作：一次性添加所有克隆节点
    const fragment = document.createDocumentFragment();
    originalContent.forEach(item => {
      fragment.appendChild(item.cloneNode(true));
    });
    this.container.appendChild(fragment);

    // 计算滚动重置点
    this.scrollHeight = contentHeight; // 此时 contentHeight 已经是原始内容的高度

    // 事件绑定 - PC端
    this.container.addEventListener('mouseenter', () => this.pause());
    this.container.addEventListener('mouseleave', () => this.resume());

    // 事件绑定 - 移动端
    this.container.addEventListener('touchstart', () => this.pause());
    this.container.addEventListener('touchend', () => setTimeout(() => this.resume(), 1000));
  }

  pause() {
    this.isScrolling = false;
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  resume() {
    if (!this.isScrolling) {
      this.isScrolling = true;
      this.lastTimestamp = null; // 重置时间戳，避免暂停后滚动距离异常
      this.rafId = requestAnimationFrame(this.scroll.bind(this));
    }
  }

  scroll(timestamp) {
    if (!this.isScrolling) return;

    if (!this.lastTimestamp) this.lastTimestamp = timestamp;
    const delta = timestamp - this.lastTimestamp;
    this.lastTimestamp = timestamp;

    // 限制最大帧时间差，防止切换标签页后回来时的大幅跳动
    const cappedDelta = Math.min(delta, 100);
    this.scrollAccumulator += (this.speed * cappedDelta) / 1000; // 浮点累积
    const scrollInt = Math.floor(this.scrollAccumulator); // 取整
    this.scrollAccumulator -= scrollInt; // 剩余小数保留用于下一次

    // 使用scrollTop代替transform，更符合原生滚动行为
    this.container.scrollTop += scrollInt;

    // 到达克隆部分时重置滚动位置，实现无缝衔接
    if (this.container.scrollTop >= this.scrollHeight) {
      this.container.scrollTop -= this.scrollHeight; // 瞬间重置到克隆内容的起始位置
    }

    this.rafId = requestAnimationFrame(this.scroll.bind(this));
  }

  observe() {
    // 组件进入视窗
    const Observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 开始 滚动
          setTimeout(() => this.resume(), this.delay)
        }
      })
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.25, // 设置阈值
    })

    Observer.observe(this.container)
  }
}
/**
* 需要在页面中引入 <script src="{{ 'aws-sdk-2.1046.0.min.js' | asset_url }}" defer></script>
* @description: 上传图片到S3
* @param {*} params 文件数据
* @param {*} s3Config s3验证信息
* @param {*} callback 回调函数
* @returns {*}
*/
export const uploadToS3 = (params, s3Config, callback) => {
  const { file, filename } = params;
  return new Promise((resolve, reject) => {
      const filePath = filename;
      let { access_key_id, secret_access_key, session_token, region, bucket } = s3Config;
      let s3Param = { Bucket: bucket, Key: filePath, Body: file, ContentType: file.type };
      let s3Client = new window.AWS.S3({ accessKeyId: access_key_id, secretAccessKey: secret_access_key, sessionToken: session_token, region });

      // 分片上传, 每5M分片, 5 * 1024 * 1024
      let queueSize = Math.ceil(file.size / 5242880);
      let upload = s3Client.upload(s3Param, {
          partSize: file.size < 5242880 ? 5242880 : file.size, queueSize,
          httpOptions: { connectTimeout: 60 * 1000 * 10, timeout: 60 * 1000 * 10 }
      }).on("httpUploadProgress", function (e) {
          callback && callback(e)
      });

      upload.send(function (err, data) {
          err ? reject(err) : resolve(data)
      })
  })
}

/**
 *
 * @param {*} copyContent copy的内容
 * @param {*} cb 回调函数
 */
export const copyFunc = (copyContent, cb) => {
  if (navigator.clipboard) {
      // clipboard api 复制
      navigator.clipboard.writeText(copyContent);
  } else {
      var textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      // 隐藏此输入框
      textarea.style.position = 'fixed';
      textarea.style.clip = 'rect(0 0 0 0)';
      textarea.style.top = '10px';
      // 赋值
      textarea.value = copyContent;
      // 选中
      textarea.select();
      // 复制
      document.execCommand('copy', true);
      // 移除输入框
      document.body.removeChild(textarea);
  }
  cb && cb()
}

/**
* @description: 社媒分享
* @param {*} type 分享的类型
* @param {*} content 分享的内容
* @returns {*} url
*/

export const getSocialShareAPI = (type, content) => {
  let url = '';
  const pageShareUrl = window.location.href;
  const updateTime = Date.now();
  const endShareUrl = `${pageShareUrl}?t=${updateTime}`
  switch (type) {
    case "facebook":
        url = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(endShareUrl);
        break;
    case "twitter":
        url = `https://twitter.com/intent/tweet?original_referer=${encodeURIComponent(endShareUrl)}&ref_src=${encodeURIComponent("twsrc^tfw|twcamp^buttonembed|twterm^share|twgr^")}&text=${encodeURIComponent(content)}&url=${encodeURIComponent(`${endShareUrl}`)}`;
        break;
    case "whatsapp":
        url = `https://api.whatsapp.com/send?text=${content}&${encodeURIComponent(endShareUrl)}`;
        break;
    case "line":
        url = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(`${endShareUrl}`)}&text=${content}`;
        break;
    case 'telegram':
			url = `https://t.me/share/url?url=${encodeURIComponent(`${endShareUrl}`)}&text=${content}`;
			break;
    default:
        url = '';
        break;
  }
  return url;
}

/**
 * 获取前一个兄弟节点的标题文本
 * @param {Element} element - 当前元素
 * @param {string} sectionClassName - section类名
 * @returns {string} 标题文本
 */
export const getPreviousSiblingHeadingText = (element, sectionClassName) => {
  // 参数验证
  if (!element || !(element instanceof Element)) {
    return 'Params error：Invalid element';
  }

  if (!sectionClassName || typeof sectionClassName !== 'string') {
    return 'Params error：Invalid class';
  }

  // 内部方法：获取响应式文本（区分PC和移动端）
  const getResponsiveText = (element) => {
    try {
      if (!element) return 'Untitled Text';

      // 检查是否为移动端
      const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;

      // 查找PC端文本（通常有hidden lg:block或类似的类）
      const pcTextElements = element.querySelectorAll('.heading');

      // 查找移动端文本（通常有block lg:hidden或类似的类）
      const mbTextElements = element.querySelectorAll('.mb_heading');

      const mbText = mbTextElements[0]?.textContent?.trim() || '';
      const pcText = pcTextElements[0]?.textContent?.trim() || '';

      const text = isMobile ? (mbText || pcText) : (pcText || mbText);

      return text;
    } catch (error) {
      console.error('getResponsiveText execution error:', error);
      return 'Failed to obtain the text.';
    }
  };

  try {
    // 找到指定的section元素
    const currentSection = element.closest(sectionClassName);
    if (!currentSection) {
      return `Not found ${sectionClassName}`;
    }

    // 获取父盒子的前一个兄弟节点
    const prevSibling = currentSection.previousElementSibling;
    if (!prevSibling) {
      return '';
    }

    // 检查前一个兄弟节点是否包含blocks-heading-content的组件
    const headingContent = prevSibling.querySelector('.blocks-heading-content');
    if (headingContent) {
      const headingElement = headingContent.querySelector('.blocks-content-heading');
      if (headingElement) {
        return getResponsiveText(headingElement);
      }
    }

    return '';
  } catch (error) {
    return 'Execution error';
  }
}
